<template>
<div>
	<div class="row">

		<div class="col-12">
			<partial-loader :loading="isFetching.person"></partial-loader>
		</div>

		<div class="col-12"
		     v-if="!isFetching.person">

			<b-alert v-if="error"
			         variant="danger"
			         show>{{ error }}</b-alert>

			<b-jumbotron class="mb-3 p-4">
				<div class="row">
					<div class="col">

						<h1 class="display-3">Veiling activiteit</h1>
						<h2 class="font-italic">{{ $t('bid.bidNumber') }} {{ $route.params.bidNumber }}</h2>

						<div v-if="person">
							<person-info :person="person"></person-info>
						</div>

						<p v-else
						   class="font-italic">
							{{ $t('buyer.noPerson') }}
						</p>
					</div>

					<div class="col-1">
						<b-button-group class="pull-right">
							<b-button :to="goBack()"
							          exact
							          v-b-tooltip.hover
							          title="Terug"
							          variant="outline-secondary"><i class="fa fa-fw fa-reply"></i></b-button>
						</b-button-group>
					</div>
				</div>
			</b-jumbotron>

		</div>
	</div>

	<div class="row">

		<div class="col-lg-12 col-xl-6">
			<b-jumbotron class="mb-3 p-4 h-100">
				<bid-number-cost></bid-number-cost>
			</b-jumbotron>
		</div>

		<div class="col-lg-12 col-xl-6">
			<b-jumbotron class="mb-3 p-4 h-100">

				<bids-list></bids-list>

			</b-jumbotron>
		</div>

	</div>

</div>
</template>

<script>
import { isNil } from 'lodash';
import PersonService from '@/services/person-service';
import BidService from '@/services/bid-service';
import BidNumberService from '@/services/bid-number-service';
import AuctionService from '@/services/auction-service';
import PartialLoader from '@/components/elements/PartialLoader';
import BidNumberCost from './BidNumberCost';
import PersonInfo from '@/components/views/Person/PersonInfo';
import BidsList from './BidsList';
import { isCancel, CancelToken } from 'axios';
import { smallDate } from '@/filters/date-filters';

export default {
	components: {
		PartialLoader,
		BidNumberCost,
		BidsList,
		PersonInfo
	},
	filters: {
		smallDate
	},
	data() {
		return {
			isFetching: {
				person: true,
				items: true
			},
			person: false,
			items: false,
			auctionBidNumbers: false,
			error: false
		}
	},
	methods: {
		fetchPerson() {
			this.isFetching.person = true;
			return BidNumberService.getByBidNumber(this.$route.params.bidNumber, { auction_id: this.$route.params.auctionId }).then(response => {
				this.isFetching.person = false;
				this.person = response.person;
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching.person = false;
				}
			});
		},
		goBack() {
			if (!isNil(this.$route.query.back)) {
				return { name: this.$route.query.back };
			} else {
				return { name: 'auction' };
			}
		}
	},
	mounted() {
		this.fetchPerson();
	}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Buyer.vue?554aa5cf